import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-table-filters-container',
  imports: [CommonModule],
  templateUrl: './table-filters-container.component.html',
  styleUrls: ['./table-filters-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableFiltersContainerComponent {}
